// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1pK6H","rightAdornment":"Header_rightAdornment__2ULOv"};